import cn from 'classnames'

import { ETooltipSide, ITooltipProps } from './tooltip.props'
import styles from './styles.module.scss'

export default function Tooltip({ side = ETooltipSide.BOTTOM, children, className }: ITooltipProps) {
  const sideStyle: Map<string, string> = new Map<string, string>([
    [ETooltipSide.BOTTOM, styles.bottom],
    [ETooltipSide.TOP, styles.top],
    [ETooltipSide.LEFT, styles.left],
    [ETooltipSide.RIGHT, styles.right],
  ])

  return <div className={cn(styles.tooltip, sideStyle.get(side), className)}>{children}</div>
}
